module.exports = __webpack_public_path__ + "img/Foodrazor-logo-part2.025c3e81.svg";